import { render, staticRenderFns } from "./Production_v3.vue?vue&type=template&id=0189e948&scoped=true"
import script from "./Production_v3.vue?vue&type=script&lang=js"
export * from "./Production_v3.vue?vue&type=script&lang=js"
import style0 from "./Production_v3.vue?vue&type=style&index=0&id=0189e948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0189e948",
  null
  
)

export default component.exports